/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Box, Grid, PageHeader } from "../../index";
import { IHeaderContainer } from "./IContainer";

export default function HeaderContainer({
  enableBreadcrumbs,
  pageTitle,
  toolbarItem,
  breadcrumSeparator,
}: IHeaderContainer) {
  const currentTheme = useTheme();

  const location = useLocation();
  return (
    <Box>
      {(pageTitle || toolbarItem || enableBreadcrumbs) && (
        <Box
          sx={(theme) => ({
            flexGrow: 1,
            px: 4,
            py: 2,
            background: currentTheme.pageHeaderBGColor?.default,
            borderBottom: `${theme.palette.mode === "light" ? "1px solid #E0E0E0" : "1px solid rgba(81, 81, 81, 1)"}`,
          })}
        >
          <Grid container>
            {enableBreadcrumbs && (
              <Grid size={12} paddingBottom={2}>
                <PageHeader
                  pathname={location.pathname}
                  separatorType={breadcrumSeparator}
                />
              </Grid>
            )}
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>{pageTitle}</Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {toolbarItem}
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
}
